var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "inbox-content" } }, [
    _vm.loading
      ? _c("div", { staticClass: "loading-spinner" })
      : _c("div", [
          _vm.answersData
            ? _c("div", [
                _c("div", { staticClass: "content-header" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.answersData.formTitle))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-header" }, [
                  _c("h6", [
                    _vm._v(
                      "Form Yanıtlanma Tarihi: " + _vm._s(_vm.formattedDate)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content-body" },
                  [
                    _vm.specialAnswer
                      ? _c("div", { staticClass: "info-item special-card" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              "Kullanıcı Adı: " +
                                _vm._s(_vm.specialAnswer.value[0].username)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              "Tam Ad: " +
                                _vm._s(_vm.specialAnswer.value[0].fullName)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filteredAnswers, function (answer, index) {
                      return answer.fieldLabel
                        ? _c("div", { key: index, staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(answer.fieldLabel)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "value" },
                              [
                                answer.fieldType === "fileUpload"
                                  ? [
                                      _c(
                                        "ul",
                                        [
                                          _c(
                                            "viewer",
                                            {
                                              attrs: {
                                                options: { inline: false },
                                              },
                                            },
                                            _vm._l(
                                              answer.value,
                                              function (url, idx) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: idx,
                                                    staticClass:
                                                      "file-list-item",
                                                  },
                                                  [
                                                    url.endsWith(".pdf")
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pdf-file",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openFile(
                                                                      url
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  attrs: {
                                                                    width: "24",
                                                                    height:
                                                                      "24",
                                                                    viewBox:
                                                                      "0 0 24 24",
                                                                  },
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d: "M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            PDF File\n                                        "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : url.endsWith(".svg")
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "svg-file",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openFile(
                                                                      url
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  attrs: {
                                                                    width: "24",
                                                                    height:
                                                                      "24",
                                                                    viewBox:
                                                                      "0 0 24 24",
                                                                  },
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d: "M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            SVG File\n                                        "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.prependHttps(
                                                                url
                                                              ),
                                                              alt:
                                                                "Image " +
                                                                (idx + 1),
                                                            },
                                                          }),
                                                        ],
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.getAnswerValue(answer)) +
                                          "\n                    "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ])
            : _c("div", { staticClass: "alert alert-warning" }, [
                _vm._v(
                  "\n            Form silindiği için cevapları görüntüleyemiyorsunuz.\n        "
                ),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }